import type { Immutable } from 'immer';
import type * as Playlists from '../playlists';
import type { Get } from './get';
export namespace Derived {
  export type LibraryItem = Immutable<Get.LibraryItem>;

  export const MEDIA_STATUS = {
    PENDING: 'PENDING',
    STARTING: 'STARTING',
    UPLOADING: 'UPLOADING',
    SEGMENTING: 'SEGMENTING',
    TRANSCODING: 'TRANSCODING',
    RE_SEGMENTING: 'RE_SEGMENTING',
    RETRYING: 'RETRYING',
    FAILED: 'FAILED',
    COMPLETE: 'COMPLETE',
    CANCELLED: 'CANCELLED',
    TIMED_OUT: 'TIMED_OUT',
  } as const;

  export type MediaStatus = (typeof MEDIA_STATUS)[keyof typeof MEDIA_STATUS];

  export type TrimMediaForm = {
    endPositionNs?: number;
    endTime: string;
    isDeletingUnusedContent: boolean;
    isTrimmed: boolean;
    startPositionNs?: number;
    startTime: string;
  };

  export type EnrichMediaForm = {
    adminApproveAiOverage: boolean;
    aiVideoLimitExceeded: boolean;
    endPositionNs?: number;
    endTime: string;
    startPositionNs?: number;
    startTime: string;
  };

  export type ModalState = {
    onSave: (pl: Playlists.Get.IncludedPlaylist[]) => void;
    selectedPlaylists: Playlists.Derived.IncludedPlaylists;
  };
}
